import { useMemo, useState } from 'react'
import { useFilteredWarehouseLocations } from 'legacy/sections/store-groups/utils/filteredWarehouseLocations.hooks'
import { type StoreGroupsFormikValues } from 'legacy/sections/store-groups/components/form/utils/form.types'
import { type WarehouseLocation } from 'legacy/common/types'

interface Props {
  showSelectedLocationsOnly?: boolean
  selectedLocationIds: StoreGroupsFormikValues['selectedLocationIds']
}

export interface StoreLocationDetails extends WarehouseLocation {}

export const useStoreGroupLocations = ({
  showSelectedLocationsOnly,
  selectedLocationIds,
}: Props) => {
  const [filter, setLocationsFilterValue] = useState<string>()

  const idFilter = useMemo(() => {
    if (showSelectedLocationsOnly) return new Set(selectedLocationIds)

    return undefined
  }, [selectedLocationIds, showSelectedLocationsOnly])

  const { data, loading, error } = useFilteredWarehouseLocations({
    filter,
    idFilter,
  })

  const locations: StoreLocationDetails[] = data || []

  const clearLocationsFilterValue = () => {
    setLocationsFilterValue(undefined)
  }

  return {
    loading,
    error,
    locationsFilterValue: filter || '',
    setLocationsFilterValue,
    clearLocationsFilterValue,
    locations,
  }
}
